import React from 'react';
import styles from './InitiativeCardInfo.module.scss';
import { InitiativeValue } from '../../../../../../../Models/InitiativeValue';
import { InitiativeCardSummary } from './InitiativeCardSummary/InitiativeCardSummary';
import { InitiativeCardDetailsList } from './InitiativeCardDetailsList/InitiativeCardDetailsList';

export interface InitiativeCardInfoProps {
  className?: string;
  initiative: InitiativeValue;
  onSeeDateRowReports: (index: number) => void;
}

export const InitiativeCardInfo = ({
  className = '',
  initiative,
  onSeeDateRowReports
}: InitiativeCardInfoProps): React.ReactElement<InitiativeCardInfoProps> => {
  return (
    <div className={`${styles.initiativeCardInfo} ${className}`}>
      <InitiativeCardSummary
        startDate={initiative.start_date}
        endDate={initiative.end_date}
        progress={initiative.progress}
        allDay={initiative.all_day}
      />
      <InitiativeCardDetailsList
        counters={initiative.counters}
        rows={initiative.rows}
        onSeeDateRowReports={onSeeDateRowReports}
      />
    </div>
  );
};
